function initializeCustomPopup() {
  document.body.addEventListener("click", function (event) {
    const trigger = event.target.closest(".js-open_notify_me_popup");

    if (trigger) {
      // Step 1: Go up to the parent wrapper
      let wrapper = trigger.closest(".bundle_list");

      if (!wrapper) {
        wrapper = trigger.closest("block-buy-buttons");
      }

      // Step 2: Find sibling modal content inside that wrapper
      const modal = wrapper?.querySelector(".modal-content");
      const variantSelect = modal?.querySelector("#variants");

      // Step 3: Get variant ID from clicked button
      const variantId = trigger.getAttribute("data-variant-id");

      // Step 4: Update the <select> options to mark the correct one as selected
      if (variantSelect && variantId) {
        Array.from(variantSelect.options).forEach(option => {
          if (option.value === variantId) {
            option.setAttribute("selected", "selected");
          } else {
            option.removeAttribute("selected");
          }
        });
        // Check if there's only one option and it's "Default Title"
        if (
          variantSelect.options.length === 1 &&
          variantSelect.options[0].text.trim() === "Default Title"
        ) {
          variantSelect.hidden = true; // or variantSelect.style.display = "none";
        }
      }

      // Step 5: Set content and open popup
      if (modal) {
        // ✅ Reset previous messages and show button again
        const existingError = modal.querySelector(".notify-error-message");
        const existingSuccess = modal.querySelector(".notify-success-message");
        const submitButton = modal.querySelector('button[type="submit"]');
        if (existingError) existingError.style.display = 'none';
        if (existingSuccess) existingSuccess.style.display = 'none';
        if (submitButton) submitButton.style.display = "block";

        const html = modal.innerHTML;
        // Set popup content and open
        window.CustomPopup.setContent({ data: html });
        window.CustomPopup.open();
        submitNotifyForm()
      } else {
        console.warn("No modal-content found within this wrapper.");
      }
    }
  });
}

function submitNotifyForm() {
  document.addEventListener("submit", function (e) {
    const form = e.target.closest(".notify-form");
    if (!form) return;

    e.preventDefault();
    // Get form values
    const email = form.querySelector("#email")?.value?.trim();
    const variantId = form.querySelector("#variants")?.value?.trim();
    const companyId = form.dataset.companyId || 'VaBYfS';
    const apiHostname = form.dataset.apiHostname || "a.klaviyo.com"; // fallback
    const productId = form.querySelector("#product")?.value;
    const submitButton = form.querySelector('button[type="submit"]');
    const successEl = form.querySelector(".notify-success-message");
    const errorEl = form.querySelector(".notify-error-message");
    const artificialCloseButton = form.querySelector('.close-popup');
    artificialCloseButton.addEventListener("click", function () {
      window.CustomPopup.close();
    })
    
    successEl.style.display = "none";
    errorEl.style.display = "none";

    if (!email || !variantId || !companyId) {
      alert("Missing required data.");
      return;
    }

    // Build request data
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    };

    fetch(`https://${apiHostname}/client/back-in-stock-subscriptions/?company_id=${companyId}`, {
      method: "POST",
      headers: {
        revision: "2024-02-15",
        "Content-Type": "application/json",
        "X-Klaviyo-Onsite": "1",
      },
      body: JSON.stringify(payload),
    })
      .then(async res => {
        if (!res.ok) throw new Error("Request failed");

        const text = await res.text(); // Try to read raw response

        if (text) {
          try {
            const data = JSON.parse(text);
            console.log("✅ Response with data:", data);
          } catch (err) {
            console.warn("⚠️ Response not valid JSON:", text);
          }
        } else {
          console.log("✅ No response body (expected for 202 Accepted)");
        }

        // alert("✅ You’ll be notified when it's back in stock!");

        submitButton.style.display = "none";
        successEl.style.display = "block";
        errorEl.style.display = "none";

        // window.CustomPopup?.success();
        
        // window.CustomPopup?.close();
      })
      .catch(err => {
        console.error("❌ Klaviyo back-in-stock failed:", err);
        successEl.style.display = "none";
        errorEl.style.display = "block";

        // window.CustomPopup?.fail();
        // alert("Something went wrong. Please try again.");
      });

  });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeCustomPopup();
});
document.addEventListener("shopify:section:load", function () {
  initializeCustomPopup();
});
